import { Box, Chip, Stack } from "@mui/material";

interface Props {
  securities: { ticker: string }[];
}

export const TickerChipCell = ({ securities }: Props) => {
  if (securities.length === 0) {
    return <Box>-</Box>;
  }

  const tickers = securities.map((s) => s.ticker).filter(Boolean);

  if (tickers.length === 0) {
    return <Box>-</Box>;
  }

  return (
    <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
      {tickers.map((ticker, index) => (
        <Chip key={index} label={ticker} size="small" />
      ))}
    </Stack>
  );
};
